import { render, staticRenderFns } from "./convocation.vue?vue&type=template&id=72b2334d"
import script from "./convocation.vue?vue&type=script&lang=js"
export * from "./convocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports